var _image;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFfa500(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    enableBackground: "new 0 0 32 32",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _image || (_image = /*#__PURE__*/React.createElement("image", {
    id: "image0",
    width: 32,
    height: 32,
    x: 0,
    y: 0,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAMAAABEpIrGAAAABGdBTUEAALGOfPtRkwAAACBjSFJN AAB6JQAAgIMAAPn/AACA6QAAdTAAAOpgAAA6mAAAF2+SX8VGAAABXFBMVEX///98SgBpPwBWNABV MwAVDQBGKgB6SQBzRQArGgAXDgB0RgAXDgBjOwBdOABHKwAfEwBqQABjOwBWNABdOABtQQBwQwAS CwATCwBPLwB8SgAWDQByRAAYDgB1RgAcEQAUDAA/JgB3RwBIKwA/JgAgEwBPLwBsQQBmPQBNLgAk FgAEAgA3IQDMegD/mQD7lwDFdgBHKwB7SgDwkACiYQAJBQCHUQCZXAA5IgD0kgBLLQCyawDLegAG BAAQCgD2lABvQwAfEwA2IABwQwAAAABFKQBKLABWNAAzHwAyHgAPCQD8lwD3lAAUDADBdAC4bgA8 JAD1kwA9JQD9mACYWwB5SQDxkQCUWQBeOAD6lgCGUACOVQALBwDUfwDQfQARCgBAJgDNewDPfAAN CABjOwASCwAWDQDHdwDRfQB4SAB9SwBCKABBJwAhFAAmFwAOCAAVDQAIBQACAQD///8CVFmLAAAA JXRSTlMAH4a/wP7bO1f2/lb9nK3a+4Wbvq5ubv7+zR3+Vf1V/f7mOtrluEkQjAAAAAFiS0dEAIgF HUgAAAAJcEhZcwAACxIAAAsSAdLdfvwAAAAHdElNRQfkChwRGhs20vnCAAABPUlEQVQ4y32SV1fC QBBGJ0EULEGIgRBjARRLdBG7qAtKsDfsir13xf//YIp6skuy39Oeufec3ZlZAEc43meE58A9XJ2/ N93XPzCo1Te48UBwaBiZyYxkG/la3tQ8Oob+Mj7RUiMEJ5EjU376FmF6ximgXIgSWmcJjubmyV4C OG/VCxgXbGMhTAiRRata1I0UrWNJJARxyapiU8DWcZkUfFlayJFC2wp9xapACNLaum1gbPONzSjZ ZmyLbHNbpuYQ3ykTwi49KEV2jnpvv12hd6F2HBz+C0eayzo75eNffHLaFXH7EGqsYguVbtX9S0ln 5ya/uOTBI/GrjCGkE17caOUaoZvbpKcAIeOddylvDup9GT2EGQLIj08yi0Pq+aWHKQivbyJTiL5/ MJ8Ayc8viSlAtaqwBe2bzUHXqcIPowRIW7BCzAwAAAAldEVYdGRhdGU6Y3JlYXRlADIwMjAtMTAt MjhUMTc6MjY6MjcrMDM6MDDu7eqJAAAAJXRFWHRkYXRlOm1vZGlmeQAyMDIwLTEwLTI4VDE3OjI2 OjI3KzAzOjAwn7BSNQAAAABJRU5ErkJggg=="
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFfa500);
export default __webpack_public_path__ + "static/media/FFA500.0a75d0444afafaba8cd98356fc99fca3.svg";
export { ForwardRef as ReactComponent };